import { makeAutoObservable, observable, runInAction } from 'mobx';
import { ApplicationState } from 'framework/applicationState';
import { MobxManager } from 'framework/mobx-integration';
import { DataReader, getItemId } from '../../notificationDataReader';
import { ActionTriggerSwitcherProps, NotificationPolicy } from './types';

export class ActionTriggerSwitcherStore {
	props: ActionTriggerSwitcherProps;
	mobx = new MobxManager();
	reader: DataReader = null;
	isEnabled = false;

	constructor() {
		makeAutoObservable(this, { mobx: false, reader: observable.ref });
	}

	init() {
		this.mobx.reaction(
			() => [this.props.type, this.props.id],
			() => void this.load(),
			{ fireImmediately: true },
		);
	}

	async load() {
		this.reader = null;
		this.isEnabled = false;

		if (!this.props.id) {
			return;
		}

		const { type, id } = this.props;
		const reader = new DataReader(ApplicationState.accountId, type, getItemId(id));
		const data = (await reader.read()) as NotificationPolicy;

		if (type !== this.props.type || id !== this.props.id) {
			return;
		}

		runInAction(() => {
			this.reader = reader;
			this.isEnabled = !!data?.isEnabled;
		});
	}

	setEnabled(value: boolean) {
		this.isEnabled = value;
		this.reader.setEnabled(value);
		this.reader.save();
	}

	get loaded() {
		return this.reader != null;
	}

	destroy() {
		this.mobx.destroy();
	}
}
